import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/web.dom-collections.for-each.js";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import "regenerator-runtime/runtime.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import Vue from 'vue';
import Vuex from 'vuex';
import Meta from 'vue-meta';
import ClientOnly from 'vue-client-only';
import NoSsr from 'vue-no-ssr';
import { createRouter } from './router.js';
import NuxtChild from './components/nuxt-child.js';
import NuxtError from '../src/layouts/error.vue';
import Nuxt from './components/nuxt.js';
import App from './App.js';
import { setContext, getLocation, getRouteData, normalizeError } from './utils';
import { createStore } from './store.js';

/* Plugins */

import nuxt_plugin_plugin_39f86781 from 'nuxt_plugin_plugin_39f86781'; // Source: ./components/plugin.js (mode: 'all')
import nuxt_plugin_appplugin_d9dd1a0a from 'nuxt_plugin_appplugin_d9dd1a0a'; // Source: ../../../node_modules/@nuxt/bridge/dist/runtime/app.plugin.mjs (mode: 'all')
import nuxt_plugin_configplugin_3886f298 from 'nuxt_plugin_configplugin_3886f298'; // Source: ../../../node_modules/@nuxt/bridge/dist/runtime/config.plugin.mjs (mode: 'all')
import nuxt_plugin_nuxtuseragent_8cecf3c0 from 'nuxt_plugin_nuxtuseragent_8cecf3c0'; // Source: ./nuxt-user-agent.js (mode: 'all')
import nuxt_plugin_cookieuniversalnuxt_17859dbf from 'nuxt_plugin_cookieuniversalnuxt_17859dbf'; // Source: ./cookie-universal-nuxt.js (mode: 'all')
import nuxt_plugin_partnerlocalesplugin_72eb964b from 'nuxt_plugin_partnerlocalesplugin_72eb964b'; // Source: ./partner-locales-plugin.ts (mode: 'all')
import nuxt_plugin_capiplugin_4dd9e4c8 from 'nuxt_plugin_capiplugin_4dd9e4c8'; // Source: ./capi.plugin.mjs (mode: 'all')
import nuxt_plugin_errorpluginserver_75b2360d from 'nuxt_plugin_errorpluginserver_75b2360d'; // Source: ../../../node_modules/@nuxt/bridge/dist/runtime/error.plugin.server.mjs (mode: 'server')
import nuxt_plugin_distplugin5197cf4d_0c2aec04 from 'nuxt_plugin_distplugin5197cf4d_0c2aec04'; // Source: ./dist.plugin.5197cf4d.mjs (mode: 'all')
import nuxt_plugin_bus_745250ba from 'nuxt_plugin_bus_745250ba'; // Source: ../src/plugins/bus.ts (mode: 'all')
import nuxt_plugin_datadog_030302be from 'nuxt_plugin_datadog_030302be'; // Source: ../src/plugins/data-dog.ts (mode: 'client')
import nuxt_plugin_globalappcontext_32774ffe from 'nuxt_plugin_globalappcontext_32774ffe'; // Source: ../src/plugins/global-app-context.ts (mode: 'all')
import nuxt_plugin_globalmixin_5f4f03c0 from 'nuxt_plugin_globalmixin_5f4f03c0'; // Source: ../src/plugins/global-mixin.ts (mode: 'all')
import nuxt_plugin_gtm_63637dfa from 'nuxt_plugin_gtm_63637dfa'; // Source: ../src/plugins/gtm.ts (mode: 'client')
import nuxt_plugin_launchdarkly_c886bab4 from 'nuxt_plugin_launchdarkly_c886bab4'; // Source: ../src/plugins/launch-darkly.ts (mode: 'client')
import nuxt_plugin_openmodal_5441a9cd from 'nuxt_plugin_openmodal_5441a9cd'; // Source: ../src/plugins/open-modal.ts (mode: 'all')
import nuxt_plugin_persistedstatepinia_68e0fd6c from 'nuxt_plugin_persistedstatepinia_68e0fd6c'; // Source: ../src/plugins/persisted-state-pinia.ts (mode: 'client')
import nuxt_plugin_vclickoutside_12eb198c from 'nuxt_plugin_vclickoutside_12eb198c'; // Source: ../src/plugins/v-click-outside.ts (mode: 'all')
import nuxt_plugin_vfocustrap_c5fe1cc4 from 'nuxt_plugin_vfocustrap_c5fe1cc4'; // Source: ../src/plugins/v-focus-trap.ts (mode: 'all')
import nuxt_plugin_vscrolllock_1c8c70cf from 'nuxt_plugin_vscrolllock_1c8c70cf'; // Source: ../src/plugins/v-scroll-lock.ts (mode: 'all')
import nuxt_plugin_vuelidate_4be42f5c from 'nuxt_plugin_vuelidate_4be42f5c'; // Source: ../src/plugins/vuelidate.ts (mode: 'all')
import nuxt_plugin_auth_7f755f62 from 'nuxt_plugin_auth_7f755f62'; // Source: ../src/plugins/auth.ts (mode: 'client')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly);

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, _objectSpread(_objectSpread({}, NoSsr), {}, {
  render: function render(h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true;
      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead');
    }
    return NoSsr.render(h, ctx);
  }
}));

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild);
Vue.component('NChild', NuxtChild);

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt);
Object.defineProperty(Vue.prototype, '$nuxt', {
  get: function get() {
    var globalNuxt = this.$root ? this.$root.$options.$nuxt : null;
    if (process.client && !globalNuxt && typeof window !== 'undefined') {
      return window.$nuxt;
    }
    return globalNuxt;
  },
  configurable: true
});
Vue.use(Meta, {
  "keyName": "head",
  "attribute": "data-n-head",
  "ssrAttribute": "data-n-head-ssr",
  "tagIDKeyName": "hid"
});
var defaultTransition = {
  "name": "page",
  "mode": "out-in",
  "appear": true,
  "appearClass": "appear",
  "appearActiveClass": "appear-active",
  "appearToClass": "appear-to"
};
var originalRegisterModule = Vuex.Store.prototype.registerModule;
function registerModule(path, rawModule) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var preserveState = process.client && (Array.isArray(path) ? !!path.reduce(function (namespacedState, path) {
    return namespacedState && namespacedState[path];
  }, this.state) : path in this.state);
  return originalRegisterModule.call(this, path, rawModule, _objectSpread({
    preserveState: preserveState
  }, options));
}
function createApp(_x) {
  return _createApp.apply(this, arguments);
}
function _createApp() {
  _createApp = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(ssrContext) {
    var config,
      store,
      router,
      app,
      next,
      route,
      path,
      inject,
      _args2 = arguments;
    return regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          inject = function _inject(key, value) {
            if (!key) {
              throw new Error('inject(key, value) has no key provided');
            }
            if (value === undefined) {
              throw new Error("inject('".concat(key, "', value) has no value provided"));
            }
            key = '$' + key;
            // Add into app
            app[key] = value;
            // Add into context
            if (!app.context[key]) {
              app.context[key] = value;
            }

            // Add into store
            store[key] = app[key];

            // Check if plugin not already installed
            var installKey = '__nuxt_' + key + '_installed__';
            if (Vue[installKey]) {
              return;
            }
            Vue[installKey] = true;
            // Call Vue.use() to install the plugin into vm
            Vue.use(function () {
              if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
                Object.defineProperty(Vue.prototype, key, {
                  get: function get() {
                    return this.$root.$options[key];
                  }
                });
              }
            });
          };
          config = _args2.length > 1 && _args2[1] !== undefined ? _args2[1] : {};
          store = createStore(ssrContext);
          _context2.next = 5;
          return createRouter(ssrContext, config, {
            store: store
          });
        case 5:
          router = _context2.sent;
          // Add this.$router into store actions/mutations
          store.$router = router;

          // Create Root instance

          // here we inject the router and store to all child components,
          // making them available everywhere as `this.$router` and `this.$store`.
          app = _objectSpread({
            head: {
              "title": undefined,
              "htmlAttrs": {
                "lang": "en"
              },
              "meta": [{
                "charset": "utf-8"
              }, {
                "name": "viewport",
                "content": "width=device-width, initial-scale=1"
              }, {
                "hid": "description",
                "name": "description",
                "content": ""
              }],
              "link": [],
              "style": [],
              "script": []
            },
            store: store,
            router: router,
            nuxt: {
              defaultTransition: defaultTransition,
              transitions: [defaultTransition],
              setTransitions: function setTransitions(transitions) {
                if (!Array.isArray(transitions)) {
                  transitions = [transitions];
                }
                transitions = transitions.map(function (transition) {
                  if (!transition) {
                    transition = defaultTransition;
                  } else if (typeof transition === 'string') {
                    transition = Object.assign({}, defaultTransition, {
                      name: transition
                    });
                  } else {
                    transition = Object.assign({}, defaultTransition, transition);
                  }
                  return transition;
                });
                this.$options.nuxt.transitions = transitions;
                return transitions;
              },
              err: null,
              errPageReady: false,
              dateErr: null,
              error: function error(err) {
                err = err || null;
                app.context._errored = Boolean(err);
                err = err ? normalizeError(err) : null;
                var nuxt = app.nuxt; // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
                if (this) {
                  nuxt = this.nuxt || this.$options.nuxt;
                }
                nuxt.dateErr = Date.now();
                nuxt.err = err;
                nuxt.errPageReady = false;
                // Used in src/server.js
                if (ssrContext) {
                  ssrContext.nuxt.error = err;
                }
                return err;
              }
            }
          }, App); // Make app available into store via this.app
          store.app = app;
          next = ssrContext ? ssrContext.next : function (location) {
            return app.router.push(location);
          }; // Resolve route
          if (ssrContext) {
            route = router.resolve(ssrContext.url).route;
          } else {
            path = getLocation(router.options.base, router.options.mode);
            route = router.resolve(path).route;
          }

          // Set context to app.context
          _context2.next = 13;
          return setContext(app, {
            store: store,
            route: route,
            next: next,
            error: app.nuxt.error.bind(app),
            payload: ssrContext ? ssrContext.payload : undefined,
            req: ssrContext ? ssrContext.req : undefined,
            res: ssrContext ? ssrContext.res : undefined,
            beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
            beforeSerializeFns: ssrContext ? ssrContext.beforeSerializeFns : undefined,
            ssrContext: ssrContext
          });
        case 13:
          // Inject runtime config as $config
          inject('config', config);
          if (process.client) {
            // Replace store state before plugins execution
            if (window.__NUXT__ && window.__NUXT__.state) {
              store.replaceState(window.__NUXT__.state);
            }
          }

          // Add enablePreview(previewData = {}) in context for plugins
          if (process.static && process.client) {
            app.context.enablePreview = function () {
              var previewData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
              app.previewData = Object.assign({}, previewData);
              inject('preview', previewData);
            };
          }
          // Plugin execution
          if (!(typeof nuxt_plugin_plugin_39f86781 === 'function')) {
            _context2.next = 19;
            break;
          }
          _context2.next = 19;
          return nuxt_plugin_plugin_39f86781(app.context, inject);
        case 19:
          if (!(typeof nuxt_plugin_appplugin_d9dd1a0a === 'function')) {
            _context2.next = 22;
            break;
          }
          _context2.next = 22;
          return nuxt_plugin_appplugin_d9dd1a0a(app.context, inject);
        case 22:
          if (!(typeof nuxt_plugin_configplugin_3886f298 === 'function')) {
            _context2.next = 25;
            break;
          }
          _context2.next = 25;
          return nuxt_plugin_configplugin_3886f298(app.context, inject);
        case 25:
          if (!(typeof nuxt_plugin_nuxtuseragent_8cecf3c0 === 'function')) {
            _context2.next = 28;
            break;
          }
          _context2.next = 28;
          return nuxt_plugin_nuxtuseragent_8cecf3c0(app.context, inject);
        case 28:
          if (!(typeof nuxt_plugin_cookieuniversalnuxt_17859dbf === 'function')) {
            _context2.next = 31;
            break;
          }
          _context2.next = 31;
          return nuxt_plugin_cookieuniversalnuxt_17859dbf(app.context, inject);
        case 31:
          if (!(typeof nuxt_plugin_partnerlocalesplugin_72eb964b === 'function')) {
            _context2.next = 34;
            break;
          }
          _context2.next = 34;
          return nuxt_plugin_partnerlocalesplugin_72eb964b(app.context, inject);
        case 34:
          if (!(typeof nuxt_plugin_capiplugin_4dd9e4c8 === 'function')) {
            _context2.next = 37;
            break;
          }
          _context2.next = 37;
          return nuxt_plugin_capiplugin_4dd9e4c8(app.context, inject);
        case 37:
          if (!(process.server && typeof nuxt_plugin_errorpluginserver_75b2360d === 'function')) {
            _context2.next = 40;
            break;
          }
          _context2.next = 40;
          return nuxt_plugin_errorpluginserver_75b2360d(app.context, inject);
        case 40:
          if (!(typeof nuxt_plugin_distplugin5197cf4d_0c2aec04 === 'function')) {
            _context2.next = 43;
            break;
          }
          _context2.next = 43;
          return nuxt_plugin_distplugin5197cf4d_0c2aec04(app.context, inject);
        case 43:
          if (!(typeof nuxt_plugin_bus_745250ba === 'function')) {
            _context2.next = 46;
            break;
          }
          _context2.next = 46;
          return nuxt_plugin_bus_745250ba(app.context, inject);
        case 46:
          if (!(process.client && typeof nuxt_plugin_datadog_030302be === 'function')) {
            _context2.next = 49;
            break;
          }
          _context2.next = 49;
          return nuxt_plugin_datadog_030302be(app.context, inject);
        case 49:
          if (!(typeof nuxt_plugin_globalappcontext_32774ffe === 'function')) {
            _context2.next = 52;
            break;
          }
          _context2.next = 52;
          return nuxt_plugin_globalappcontext_32774ffe(app.context, inject);
        case 52:
          if (!(typeof nuxt_plugin_globalmixin_5f4f03c0 === 'function')) {
            _context2.next = 55;
            break;
          }
          _context2.next = 55;
          return nuxt_plugin_globalmixin_5f4f03c0(app.context, inject);
        case 55:
          if (!(process.client && typeof nuxt_plugin_gtm_63637dfa === 'function')) {
            _context2.next = 58;
            break;
          }
          _context2.next = 58;
          return nuxt_plugin_gtm_63637dfa(app.context, inject);
        case 58:
          if (!(process.client && typeof nuxt_plugin_launchdarkly_c886bab4 === 'function')) {
            _context2.next = 61;
            break;
          }
          _context2.next = 61;
          return nuxt_plugin_launchdarkly_c886bab4(app.context, inject);
        case 61:
          if (!(typeof nuxt_plugin_openmodal_5441a9cd === 'function')) {
            _context2.next = 64;
            break;
          }
          _context2.next = 64;
          return nuxt_plugin_openmodal_5441a9cd(app.context, inject);
        case 64:
          if (!(process.client && typeof nuxt_plugin_persistedstatepinia_68e0fd6c === 'function')) {
            _context2.next = 67;
            break;
          }
          _context2.next = 67;
          return nuxt_plugin_persistedstatepinia_68e0fd6c(app.context, inject);
        case 67:
          if (!(typeof nuxt_plugin_vclickoutside_12eb198c === 'function')) {
            _context2.next = 70;
            break;
          }
          _context2.next = 70;
          return nuxt_plugin_vclickoutside_12eb198c(app.context, inject);
        case 70:
          if (!(typeof nuxt_plugin_vfocustrap_c5fe1cc4 === 'function')) {
            _context2.next = 73;
            break;
          }
          _context2.next = 73;
          return nuxt_plugin_vfocustrap_c5fe1cc4(app.context, inject);
        case 73:
          if (!(typeof nuxt_plugin_vscrolllock_1c8c70cf === 'function')) {
            _context2.next = 76;
            break;
          }
          _context2.next = 76;
          return nuxt_plugin_vscrolllock_1c8c70cf(app.context, inject);
        case 76:
          if (!(typeof nuxt_plugin_vuelidate_4be42f5c === 'function')) {
            _context2.next = 79;
            break;
          }
          _context2.next = 79;
          return nuxt_plugin_vuelidate_4be42f5c(app.context, inject);
        case 79:
          if (!(process.client && typeof nuxt_plugin_auth_7f755f62 === 'function')) {
            _context2.next = 82;
            break;
          }
          _context2.next = 82;
          return nuxt_plugin_auth_7f755f62(app.context, inject);
        case 82:
          // Lock enablePreview in context
          if (process.static && process.client) {
            app.context.enablePreview = function () {
              console.warn('You cannot call enablePreview() outside a plugin.');
            };
          }

          // Wait for async component to be resolved first
          _context2.next = 85;
          return new Promise(function (resolve, reject) {
            // Ignore 404s rather than blindly replacing URL in browser
            if (process.client) {
              var _router$resolve = router.resolve(app.context.route.fullPath),
                _route = _router$resolve.route;
              if (!_route.matched.length) {
                return resolve();
              }
            }
            router.replace(app.context.route.fullPath, resolve, function (err) {
              // https://github.com/vuejs/vue-router/blob/v3.4.3/src/util/errors.js
              if (!err._isRouter) return reject(err);
              if (err.type !== 2 /* NavigationFailureType.redirected */) return resolve();

              // navigated to a different route in router guard
              var unregister = router.afterEach( /*#__PURE__*/function () {
                var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(to, from) {
                  return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) switch (_context.prev = _context.next) {
                      case 0:
                        if (process.server && ssrContext && ssrContext.url) {
                          ssrContext.url = to.fullPath;
                        }
                        _context.next = 3;
                        return getRouteData(to);
                      case 3:
                        app.context.route = _context.sent;
                        app.context.params = to.params || {};
                        app.context.query = to.query || {};
                        unregister();
                        resolve();
                      case 8:
                      case "end":
                        return _context.stop();
                    }
                  }, _callee);
                }));
                return function (_x2, _x3) {
                  return _ref.apply(this, arguments);
                };
              }());
            });
          });
        case 85:
          return _context2.abrupt("return", {
            store: store,
            app: app,
            router: router
          });
        case 86:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return _createApp.apply(this, arguments);
}
export { createApp, NuxtError };